import { render, staticRenderFns } from "./MenuNavBar.vue?vue&type=template&id=12e81f07&"
import script from "./MenuNavBar.vue?vue&type=script&lang=js&"
export * from "./MenuNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports